import { render, staticRenderFns } from "./Regions.vue?vue&type=template&id=d29de338&scoped=true"
import script from "./Regions.vue?vue&type=script&lang=js"
export * from "./Regions.vue?vue&type=script&lang=js"
import style0 from "./Regions.vue?vue&type=style&index=0&id=d29de338&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d29de338",
  null
  
)

export default component.exports